import {ObjectKeys} from '../api/objectkeys'
import {AlarmsData, DigitalLicensesStatsData} from '../api/statistics/models'
import { getLicenseStatus } from './digitallicensContext'
import * as User from '../api/usermanagement/models'
import * as UserModels from '../api/usermanagement/models'

const BOM = '\ufeff'

const downloadCSV = (filename: string, csv: string) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    if (navigator.msSaveBlob) {
        // Needed for IE 10+
        navigator.msSaveBlob(blob, filename)
    } else {
        const link = document.createElement('a')
        if (link.download !== undefined) {
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}

// Translate dd-mm-yyyy to yyyy-mm-dd
// The moments lib gives a wrong result for it, so we do this manually instead
const dateStringToExcelDate = (dateString: string) => {
    var parts = dateString.split("-")
    if (parts.length !== 3) {
        // Wrong
        return dateString
    }
    // Reverse them
    return parts[2] + '-' + parts[1] + '-' + parts[0]
}

const cellToString = (cell: any, index: number, dateColumns: number[], timeColumns: number[]): string => {
    if (!cell) {
        return ""
    }

    if (dateColumns.indexOf(index) >= 0 && typeof(cell) === "string") {
        return dateStringToExcelDate(cell)
    }

    if (timeColumns.indexOf(index) >= 0 && typeof(cell) === "string") {
        var parts = cell.split(" ")
        if (parts.length !== 2) {
            return cell
        }
        return dateStringToExcelDate(parts[0]) + ' ' + parts[1]
    }

    return "" + cell
}

const headersToString = (headers: string[], separator: string): string => {
    return headers.join(separator) + '\n'
}

const cellsToString = (keys: string[], rows: ObjectKeys[], dateColumns: number[], timeColumns: number[], separator: string): string => {
    var csv = ""
    rows.forEach(row => {
        let cells: string[] = []
        keys.forEach((key, index) => {
            cells.push(cellToString(row[key], index, dateColumns, timeColumns))
        })
        csv += cells.join(separator) + '\n'
    })
    return csv
}

export const exportCSVFromObjects = (filename: string, headers: string[], keys: string[], rows: ObjectKeys[], dateColumns: number[], timeColumns: number[], separator: string = ';') => {
    if (!rows || rows.length < 1) {
        return
    }

    // Add the keys to the file
    var csv = BOM + headersToString(headers, separator)
    csv += cellsToString(keys, rows, dateColumns, timeColumns, separator)

    downloadCSV(filename, csv)
}

export const exportTransactionsCSV = (filename: string, headers1: string[], keys1: string[], rows1: ObjectKeys[], headers2: string[], keys2: string[], rows2: ObjectKeys[], timeColumns1: number[], timeColumns2: number[], separator: string = ';') => {
    // Add the keys to the file
    var csv = BOM + headers1.join(separator) + '\n'
    csv += cellsToString(keys1, rows1, [], timeColumns1, separator)
    csv += '\n'
    csv += headers2.join(separator) + '\n'
    csv += cellsToString(keys2, rows2, [], timeColumns2, separator)

    downloadCSV(filename, csv)
}

export const exportAlarmsCSV = (filename: string, headers: string[], rows: AlarmsData[], renderType: (level: number) => string, renderStatus: (on: number) => string, separator: string = ';') => {
    if (!rows || rows.length < 1) {
        return
    }

    // Add the keys to the file
    var csv = BOM + headers.join(separator) + '\n'

    rows.forEach(row => {
        let cells: string[] = []
        cells.push(cellToString(row.deviceName, 0, [], []))
        cells.push(cellToString(row.time, 1, [], [1]))
        cells.push(cellToString(row.unitOrTicket, 2, [], []))
        cells.push(cellToString(row.text, 3, [], []))
        cells.push(cellToString(renderType(row.type), 4, [], []))
        cells.push(cellToString(renderStatus(row.status), 5, [], []))
        csv += cells.join(separator) + '\n'
    })

    downloadCSV(filename, csv)
}

export const exportCSV = (filename: string, headers: string[], rows: Array<string|number>[], dateColumns: number[], timeColumns: number[], separator: string = ';') => {
    if (!rows || rows.length < 1) {
        return
    }

    // Add the keys to the file
    var csv = '\ufeff' + headers.join(separator) + '\n'

    rows.forEach(row => {
        let cells: string[] = []
        row.forEach((cell, index) => {
            cells.push(cellToString(cell, index, dateColumns, timeColumns))
        })
        csv += cells.join(separator) + '\n'
    })

    downloadCSV(filename, csv)
}

const renderUserPermissionsCell = (user: UserModels.User) => {
    let u: string[] = []
    if (user.permissionAlarms) { u.push("alarmer") }
    if (user.permissionDoorOpener) { u.push("SMS døråbner") }
    if (user.permissionGlobalSearch) { u.push("parkantopslag") }
    if (user.permissionInfoModule) { u.push("infomodul") }
    if (user.permissionMobileBase) { u.push("mobilbase") }
    if (user.permissionStatistics) { u.push("statistik") }
    if (user.permissionUserManagement) { u.push("brugerhåndtering") }
    if (user.permissionDigitalLicenses) { u.push("digitale licenser") }
    var s = u.join(", ")
    if (s.length > 0) {
        return s.charAt(0).toUpperCase() + s.slice(1)
    }
    // No permissions
    return "-"
}

const renderUserLocNames = (targetRow: any, locNames: any) => {

    let locations: any[] = []
    targetRow.locationsAccess.forEach((location: any) => {
        var ld = locNames.find((l: any) => l.id === location)
        if (ld) {
            locations.push(ld.name)
        }
    })

    if (locations.length > 0){
        return locations.join(", ")
    }
    else{
        return ""
    }

}

const userCellsToString = (keys: string[], rows: any, dateColumns: number[], timeColumns: number[], permsUser: any, locationData: any, separator: string): string => {
    var csv = ""
    rows.forEach((row: any) => {
        let cells: string[] = []
        cells.push(cellToString(row.username, 0, [], []))
        cells.push(cellToString(row.name, 1, [], []))
        cells.push(cellToString(row.email, 2, [], []))
        cells.push(cellToString(row.title, 3, [], []))
        cells.push(cellToString(row.phone, 4, [], []))
        cells.push(cellToString(row.active ? "Ja" : "Nej", 5, [], []))
        cells.push(cellToString(renderUserPermissionsCell(row), 6, [], []))
        cells.push(cellToString(renderUserLocNames(row, locationData), 7, [], []))
        csv += cells.join(separator) + '\n'
    })
    return csv
}

export const exportUsers = 
    (filename: string, headers: string[], keys: string[], rows: User.User[], dateColumns: number[], timeColumns: number[], permsUser: any, locData: any, separator: string = ';') => {
    if (!rows || rows.length < 1) {
        return
    }
    headers.push("locationsAccess")
    keys.push("locationsAccess")

    // Add the keys to the file
    var csv = BOM + headersToString(headers, separator)
    csv += userCellsToString(keys, rows, dateColumns, timeColumns, permsUser, locData, separator)

    downloadCSV(filename, csv)
}

export const exportDigitalLicensesCSV = (filename: string, headers: string[], rows: DigitalLicensesStatsData[], separator: string = ';') => {
    if (!rows || rows.length < 1) {
        return
    }

    // Add the keys to the file
    var csv = BOM + headers.join(separator) + '\n'

    rows.forEach(row => {
        let licensStatus = getLicenseStatus(0, row.licenseType, null, row.status, row.startDate, row.count, row.period)
        let cells: string[] = []

        cells.push(cellToString(row.id, 0, [], []))
        cells.push(cellToString(row.period, 1, [], []))
        cells.push(cellToString(row.area, 2, [], []))
        cells.push(cellToString(row.priceString, 3, [], []))
        cells.push(cellToString(row.startDateString, 4, [4], []))
        cells.push(cellToString(row.endDateString, 5, [5], []))
        if ( licensStatus != "?"){
            cells.push(cellToString(licensStatus, 6, [], []))
        }
        cells.push(cellToString(row.name, 7, [], []))
        cells.push(cellToString(row.companyName, 8, [], []))
        cells.push(cellToString(row.cvr, 9, [], []))
        cells.push(cellToString(row.plate, 10, [], []))
        csv += cells.join(separator) + '\n'
    })

    downloadCSV(filename, csv)
}
